<ion-content aria-label="Modal">
  <div *ngIf="showCloseButton" class="header"><ion-icon (click)="dismiss()" name="close-circle-outline"></ion-icon></div>
  <iframe *ngIf="safeResourceUrl" [src]="safeResourceUrl" class="dynamic-content"></iframe>
</ion-content>